module.exports = __webpack_public_path__ + "img/parkingTopBg.b3822f60.png";